"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItemCheckbox = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _checkbox = require("../../checkbox");
var _MenuItem = require("../components/MenuItem");
const noopChangeHandler = () => {
  // This is provided to the onChange handler of the input. It's only
  // here because React throws out a warning if you don't include it AND the value prop.
  // However, we do something special with the onClick event in the label
  // so we're all good.
  // Quiet please, React. ty.
};
const MenuItemCheckbox = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    checkedState,
    children,
    onClick,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_MenuItem.MenuItem, (0, _extends2.default)({}, rest, {
    ref: ref,
    role: "menuitemcheckbox",
    "aria-checked": checkedState === "checked",
    onClick: onClick,
    closeOnSelect: false,
    contentBefore: /*#__PURE__*/_react.default.createElement(_checkbox.Checkbox, {
      "aria-hidden": true,
      checkedState: checkedState,
      omitHiddenInput: true,
      onClick: noopChangeHandler
    })
  }), children);
});
exports.MenuItemCheckbox = MenuItemCheckbox;
MenuItemCheckbox.displayName = "MenuItemCheckbox";
//# sourceMappingURL=MenuItemCheckbox.js.map